<template>
  <div class="task-description-editor">
    <TelegramDualEditor
      :model-value="modelValue"
      :members="members"
      :project-id="projectId"
      :placeholder="placeholder"
      :enable-wysiwyg="enableWysiwyg"
      :clipboard-upload-enabled="clipboardUploadEnabled"
      :attachment-context="attachmentContext"
      min-height="200px"
      @update:modelValue="$emit('update:modelValue', $event)"
      @upload-finished="$emit('upload-finished', $event)"
    />
    <div class="task-description-actions">
      <button class="btn-sm btn-secondary" :disabled="!previewEnabled" @click="$emit('preview')">
        {{ s__('TaskDetail|Preview') }}
      </button>
      <button class="btn-sm btn-secondary" @click="$emit('cancel')">
        {{ s__('TaskDetail|Cancel') }}
      </button>
      <button class="btn-sm btn-primary" :disabled="saveDisabled" @click="$emit('save')">
        {{ s__('TaskDetail|Save') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { s__ } from '@/locale'
import TelegramDualEditor from '@/components/common/TelegramDualEditor.vue'

defineProps({
  modelValue: { type: String, default: '' },
  members: { type: Array, default: () => [] },
  projectId: { type: [String, Number], default: null },
  placeholder: { type: String, default: '' },
  previewEnabled: { type: Boolean, default: true },
  saveDisabled: { type: Boolean, default: false },
  enableWysiwyg: { type: Boolean, default: true },
  clipboardUploadEnabled: { type: Boolean, default: false },
  attachmentContext: { type: Object, default: () => ({}) },
})

defineEmits(['update:modelValue', 'preview', 'cancel', 'save', 'upload-finished'])
</script>

<style scoped>
.task-description-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

@media (max-width: 768px) {
  .task-description-actions {
    width: 100%;
    flex-wrap: wrap;
  }

  .task-description-actions > .btn-sm {
    flex: 1 1 calc(50% - 4px);
    min-width: 0;
    justify-content: center;
    text-align: center;
  }
}
</style>
